import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const usageLimitSchema = z.object({
  resumesCreated: z.number().int(),
  resumesLimit: z.number().int(),
  aiGenerationsUsed: z.number().int(),
  aiGenerationsLimit: z.number().int(),
  // Monthly auto-apply counter + hard cap
  applicationsUsed: z.number().int(),
  applicationsLimit: z.number().int(),
  // Job profiles (no daily reset needed — checked at create time)
  jobProfilesLimit: z.number().int().default(1),
  // Daily counters — reset at midnight UTC via todayResetAt
  applicationsTodayCount: z.number().int().default(0),
  applicationsPerDayLimit: z.number().int().default(0),
  autoApplyBurstPerHour: z.number().int().default(0),
  aiTailoringsTodayCount: z.number().int().default(0),
  aiTailoringsPerDayLimit: z.number().int().default(0),
});

export class UsageLimitDto extends createZodDto(usageLimitSchema) {}

export * from "./paid-spend.dto";
